export*from"@lit/reactive-element/decorators/property.js";
